import React from "react";
import { ErrorMessage, FieldArray, getIn } from "formik";
import { Output } from "../../Text";
import {
  ErrorMessage as BronsonErrorMessage,
  Fieldset,
  Form,
  ContentSection,
} from "@vwfs-bronson/bronson-react";
import { UploadItemState } from "../Polyfill";
import { MAX_FILE_COUNT } from "./Api";

import { SessionContext } from "../../services/api/Session";
import PropTypes from "prop-types";
import { FormSection2 } from "../../pages/Sections/FormSection";
import { DocumentUploadFieldArray } from "./DocumentUploadFieldArray";
import { Redirect } from "react-router-dom";

class DocumentUploadSection extends React.Component {
  render() {
    const {
      closed,
      success,
      showEditButton,
      onIconClick,
      form,
      buttons,
      containerRef,
    } = this.props;

    return (
      <SessionContext.Consumer>
        {({ transactionId }) =>
          !transactionId ? (
            <Redirect to={"/error"} />
          ) : (
            <FormSection2
              containerRef={containerRef}
              title={Output.resolve(
                "pages.applicationForm.panels.documentUpload.title"
              )}
              subtitle={Output.resolve(
                "pages.applicationForm.panels.documentUpload.subtitle"
              )}
              success={success}
              expanded={!closed}
              onHeaderClick={onIconClick}
              edit={
                !showEditButton
                  ? undefined
                  : {
                      label: Output.resolve("pages.applicationForm.buttonEdit"),
                      onClick: onIconClick,
                    }
              }
            >
              <Form floatingLabel {...form}>
                <>
                  {Output.resolveAsMarkdown(
                    "pages.applicationForm.panels.documentUpload.descriptionText"
                  )}
                  <ContentSection.ComponentWrapper>
                    <FieldArray
                      name={FIELD_NAME}
                      render={(props) => (
                        <DocumentUploadFieldArray
                          {...props}
                          id={"document-upload"}
                          transactionId={transactionId}
                        />
                      )}
                    />
                  </ContentSection.ComponentWrapper>

                  <ErrorMessage
                    name={FIELD_ARRAY_NAME}
                    render={(message) => {
                      return <BronsonErrorMessage error={message} />;
                    }}
                  />
                </>
                <Fieldset>
                  <Fieldset.Row>{buttons}</Fieldset.Row>
                </Fieldset>
              </Form>
            </FormSection2>
          )
        }
      </SessionContext.Consumer>
    );
  }
}

DocumentUploadSection.propTypes = {};

const FIELD_NAME = "documents";
const FIELD_ARRAY_NAME = "documentsArray";

DocumentUploadSection.defaultProps = {
  validate: (values) => {
    const errors = {};

    const files = getIn(values, FIELD_NAME);

    if (files.filter((f) => f.state === UploadItemState.LOADING).length) {
      errors[FIELD_ARRAY_NAME] = Output.resolve("generic.errors.D004");
    } else {
      const effectiveFileCount =
        Array.isArray(files) &&
        files.filter((f) => f.state === UploadItemState.SUCCESS).length;

      if (effectiveFileCount <= 0) {
        errors[FIELD_ARRAY_NAME] = Output.resolve("generic.errors.D010");
      } else if (effectiveFileCount > MAX_FILE_COUNT) {
        errors[FIELD_ARRAY_NAME] = Output.template(
          Output.resolve("generic.errors.D008"),
          { maxCount: MAX_FILE_COUNT }
        );
      }
    }

    return errors;
  },
};

DocumentUploadSection.propTypes = {
  closed: PropTypes.bool,
  success: PropTypes.bool,
  showEditButton: PropTypes.bool,
  onIconClick: PropTypes.func,
  form: PropTypes.object,
  buttons: PropTypes.node,
  containerRef: PropTypes.any,
};

export { DocumentUploadSection };
